<template>
  <SimpleComparisonRow label="Price" :data="data" :number-products="numberProducts" :index="index" :no-highlight="$parent.noHighlight">
    <template v-slot="{ columnData, index }">
      <div class="similar-comparison-data-body">
        <span v-if="columnData.value.value === null" v-html="columnData.value.formatted" />
        <span v-else>
          <span v-if="columnData.value.msrp" class="list-price-crossed" v-html="columnData.value.msrp"></span>
          <span v-html="columnData.value.formatted" />
        </span>
      </div>
    </template>
  </SimpleComparisonRow>
</template>

<script>
import SimpleComparisonRow from '@/components/shared/simple-comparison/SimpleComparisonRow';

export default {
  components: {
    SimpleComparisonRow,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    numberProducts: {
      type: Number,
      default: 3,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
};
</script>
